var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 154,
    viewBox: "0 0 117 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2177 70.9208C42.3177 68.4108 48.8277 66.9208 55.9177 66.4308C55.3077 66.1008 54.6977 65.7808 54.0777 65.4508C52.7277 64.6408 51.2477 63.8308 49.8977 63.0208C48.5477 62.0808 47.1977 61.2708 46.1177 60.1908C44.0977 58.1708 42.6077 55.7408 42.6077 52.3608C42.6077 44.1308 51.5077 42.1108 58.9377 42.1108C60.4177 42.1108 63.2577 42.6508 64.7377 43.0508C72.0277 45.0708 75.7977 50.2008 76.4777 57.7608V58.7008H90.6477L90.5077 57.6208C89.9677 39.6808 75.9377 27.8008 58.6677 27.8008C43.6877 27.8008 27.0977 33.8708 27.0977 52.2208C27.0977 60.5508 30.8777 66.3508 36.2277 70.9108L36.2177 70.9208Z",
    fill: "#1F7888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2494 82.181C79.3994 81.411 78.5294 80.691 77.6394 79.991C73.1194 78.661 68.0094 77.861 62.0494 77.791C61.7794 77.791 61.5094 77.791 61.2394 77.791C56.5794 77.791 52.4294 78.2611 48.6794 79.0911C51.5494 80.6711 54.3994 82.171 57.0494 83.671C58.6694 84.611 60.6894 85.691 62.7194 86.911C64.7394 87.991 66.8994 89.341 68.7894 90.691C72.6994 93.661 75.5394 96.901 75.5394 100.811V101.891C75.5394 109.851 67.8494 111.871 60.4294 111.871C50.7194 111.871 43.9694 106.611 42.4894 96.761L42.3594 95.951H27.1094L27.2394 97.0311C28.8594 116.051 43.8294 126.041 61.6394 126.041C76.7494 126.041 90.3794 117.951 90.3794 100.811C90.3794 93.121 85.9294 87.051 80.2594 82.191L80.2494 82.181Z",
    fill: "#1F7888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 148L31 136H45.78L52.57 148H67.3",
    stroke: "#E97A69",
    strokeWidth: 11.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6992 148L74.6992 136H89.4792L96.2692 148H110.999",
    stroke: "#E97A69",
    strokeWidth: 11.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4292 148H7.69922",
    stroke: "#E97A69",
    strokeWidth: 11.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6L30 18H44.78L51.57 6H66.3",
    stroke: "#E97A69",
    strokeWidth: 11.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6992 6L73.6992 18H88.4792L95.2692 6H109.999",
    stroke: "#E97A69",
    strokeWidth: 11.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4292 6H6.69922",
    stroke: "#E97A69",
    strokeWidth: 11.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMin);
export default __webpack_public_path__ + "static/media/logo-min.b3e9d96985005abca844bb85f01ba18e.svg";
export { ForwardRef as ReactComponent };